import { BadgeDesignTokens } from '@primeuix/themes/aura/badge';

export const badgeTokens: BadgeDesignTokens = {
  root: {
    borderRadius: '{border.radius.md}',
    padding: '0 0.5rem',
    fontSize: '0.75rem',
    fontWeight: '700',
    minWidth: '1.25rem',
    height: '1.25rem',
  },
  dot: {
    size: '0.5rem',
  },
  sm: {
    fontSize: '0.75rem',
    minWidth: '1.25rem',
    height: '1.25rem',
  },
  lg: {
    fontSize: '0.875rem',
    minWidth: '1.5rem',
    height: '1.5rem',
  },
  xl: {
    fontSize: '1rem',
    minWidth: '2rem',
    height: '2rem',
  },
  colorScheme: {
    light: {
      primary: {
        background: '{color.brand.main}',
        color: '{color.brand.contrast}',
      },
      secondary: {
        background: '{color.brand.contrast}',
        color: '{color.brand.main}',
      },
      success: {
        background: '{color.success.main}',
        color: '{color.brand.contrast}',
      },
      info: {
        background: '{color.info.main}',
        color: '{color.brand.contrast}',
      },
      warn: {
        background: '{color.warning.main}',
        color: '{color.brand.contrast}',
      },
      danger: {
        background: '{color.fail.main}',
        color: '{color.brand.contrast}',
      },
      contrast: {
        background: '{color.brand.contrast}',
        color: '{color.main.primary}',
      },
    },
    dark: {
      primary: {
        background: '{color.brand.main}',
        color: '{color.brand.contrast}',
      },
      secondary: {
        background: '{color.brand.contrast}',
        color: '{color.brand.main}',
      },
      success: {
        background: '{color.success.main}',
        color: '{color.brand.contrast}',
      },
      info: {
        background: '{color.info.main}',
        color: '{color.brand.contrast}',
      },
      warn: {
        background: '{color.warning.main}',
        color: '{color.brand.contrast}',
      },
      danger: {
        background: '{color.fail.main}',
        color: '{color.brand.contrast}',
      },
      contrast: {
        background: '{color.brand.contrast}',
        color: '{color.main.primary}',
      },
    },
  },
};
